<script lang="ts">
    import type Monster from "../../../lib/monster";
    import { GamePhases } from "../types";
    import { phase } from '../stores/game-phase';

    export let monster: Monster;
    export let onSetMoves: () => void;

    let selectedMoves: string[] = [];
</script>

<h3>
    {#if ($phase === GamePhases.SetMoves)}
        {#if (selectedMoves.length === monster.serialized.numMoves)}
            Moves selected
        {:else}
            Set Moves ({monster.serialized.numMoves} spots)
        {/if}
    {:else}
        Select Move
    {/if}
</h3>
{#if ($phase === GamePhases.SetMoves)}
    <form>
        {#each monster.serialized.moves as { name } (name)}
            <label>
                <input
                    type=checkbox
                    on:change={() => {
                        if (selectedMoves.includes(name)) {
                            selectedMoves = selectedMoves.filter(move => move !== name);
                        } else {
                            selectedMoves = selectedMoves.concat(name);
                            if (selectedMoves.length === monster.serialized.numMoves) {
                                onSetMoves();
                            }
                        }
                    }}
                    checked={selectedMoves.includes(name)}
                    disabled={selectedMoves.length === monster.serialized.numMoves}
                >
                {name}
            </label>
        {/each}
    </form>
{:else}
    <div>
        {#each selectedMoves as name (name)}
            <button>
                {name}
            </button>
        {/each}
    </div>
{/if}

<style>

</style>